// src/Services/ConsultationPage/consultationsData.js
// Услуги и цены из предоставленного прайс-листа. Перед публикацией проверьте формулировки и цены.
const consultations = [
  {
    slug: "priem-ginekologa-pervichnyj-vysshaya-kategoriya",
    code: "B01.001.001",
    title: "Первичный приём врача-акушера-гинеколога",
    h1: "Первичный приём акушера-гинеколога в Екатеринбурге",
    qualification:
      "Врач с учёной степенью К.М.Н. или квалификацией «врач высшей категории»",
    price: 2600,
    specialty: "акушер-гинеколог",
    scheduleSection: "Прием Гинеколога",
    titleSeo:
      "Первичный приём гинеколога в Екатеринбурге — 2 600 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация врача-акушера-гинеколога с учёной степенью К.М.Н. или высшей квалификационной категорией в УрНИИДВиИ в Екатеринбурге. Стоимость — 2 600 рублей.",
    content:
      "На первичном приёме врач уточняет жалобы и медицинский анамнез, оценивает предоставленные медицинские документы и определяет, какие дальнейшие обследования или консультации могут потребоваться.",
  },
  {
    slug: "priem-ginekologa-povtornyj",
    code: "B01.001.002",
    title: "Повторный приём врача-акушера-гинеколога",
    h1: "Повторный приём акушера-гинеколога в Екатеринбурге",
    qualification:
      "Врач с учёной степенью К.М.Н. и/или квалификацией «врач высшей категории»; в течение месяца",
    price: 1700,
    specialty: "акушер-гинеколог",
    scheduleSection: "Прием Гинеколога",
    titleSeo:
      "Повторный приём гинеколога в Екатеринбурге — 1 700 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация врача-акушера-гинеколога в УрНИИДВиИ в Екатеринбурге в течение месяца. Стоимость — 1 700 рублей.",
    content:
      "Повторный приём предназначен для продолжения консультации, оценки результатов обследований и обсуждения дальнейшей тактики с врачом.",
  },
  {
    slug: "priem-dermatovenerologa-pervichnyj",
    code: "B01.008.001",
    title: "Первичный приём врача-дерматовенеролога",
    h1: "Первичный приём дерматовенеролога в Екатеринбурге",
    qualification: "Первичная консультация",
    price: 2100,
    specialty: "дерматовенеролог",
    scheduleSections: [
      "Дерматология взрослая",
      "Детский дерматологический приём",
      "Мужская венерология",
      "Женская венерология",
      "Приём сифилидолога",
    ],
    titleSeo:
      "Первичный приём дерматовенеролога в Екатеринбурге — 2 100 ₽ | УрНИИДВиИ",
    description:
      "Первичный приём врача-дерматовенеролога в УрНИИДВиИ в Екатеринбурге. Уточните стоимость и порядок записи. Цена по прайсу — 2 100 рублей.",
    content:
      "На первичной консультации врач уточняет жалобы, историю их появления, изучает имеющиеся медицинские документы и определяет дальнейший план обследования при необходимости.",
  },
  {
    slug: "priem-dermatovenerologa-povtornyj",
    code: "B01.008.002",
    title: "Повторный приём врача-дерматовенеролога",
    h1: "Повторный приём дерматовенеролога в Екатеринбурге",
    qualification: "В составе курса амбулаторного лечения",
    price: 1500,
    specialty: "дерматовенеролог",
    scheduleSections: [
      "Дерматология взрослая",
      "Детский дерматологический приём",
      "Мужская венерология",
      "Женская венерология",
      "Приём сифилидолога",
    ],
    titleSeo: "Повторный приём дерматовенеролога — 1 500 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация дерматовенеролога в рамках курса амбулаторного лечения в УрНИИДВиИ, Екатеринбург. Стоимость — 1 500 рублей.",
    content:
      "Повторная консультация проводится в рамках курса амбулаторного лечения. Врач оценивает динамику состояния и при необходимости корректирует дальнейшие рекомендации.",
  },
  {
    slug: "priem-dermatovenerologa-pervichnyj-vysshaya-kategoriya",
    code: "B01.008.001",
    title: "Первичный приём дерматовенеролога (К.М.Н. / высшая категория)",
    h1: "Первичный приём дерматовенеролога высшей категории в Екатеринбурге",
    qualification:
      "С учёной степенью К.М.Н. или квалификацией «врач высшей категории»",
    price: 2600,
    specialty: "дерматовенеролог",
    scheduleSections: [
      "Дерматология взрослая",
      "Детский дерматологический приём",
      "Мужская венерология",
      "Женская венерология",
      "Приём сифилидолога",
    ],
    titleSeo: "Приём дерматовенеролога высшей категории — 2 600 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация дерматовенеролога с учёной степенью К.М.Н. или высшей квалификационной категорией в УрНИИДВиИ. Цена — 2 600 рублей.",
    content:
      "Врач уточняет жалобы и анамнез, оценивает имеющиеся обследования и определяет дальнейшие шаги диагностики и наблюдения с учётом клинической ситуации.",
  },
  {
    slug: "priem-dermatovenerologa-povtornyj-vysshaya-kategoriya",
    code: "B01.008.002",
    title: "Повторный приём дерматовенеролога (К.М.Н. / высшая категория)",
    h1: "Повторный приём дерматовенеролога высшей категории в Екатеринбурге",
    qualification:
      "С учёной степенью К.М.Н. или квалификацией «врач высшей категории»; в течение месяца",
    price: 1700,
    specialty: "дерматовенеролог",
    scheduleSections: [
      "Дерматология взрослая",
      "Детский дерматологический приём",
      "Мужская венерология",
      "Женская венерология",
      "Приём сифилидолога",
    ],
    titleSeo:
      "Повторный приём дерматовенеролога высшей категории — 1 700 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация дерматовенеролога с учёной степенью К.М.Н. или высшей квалификационной категорией в течение месяца. Цена — 1 700 рублей.",
    content:
      "На повторной консультации врач оценивает результаты назначенного обследования и изменения состояния пациента, после чего обсуждает дальнейший план наблюдения.",
  },
  {
    slug: "priem-dermatovenerologa-dmn",
    code: "B01.008.001",
    title: "Первичный приём дерматовенеролога, доктор медицинских наук",
    h1: "Приём дерматовенеролога, доктора медицинских наук, в Екатеринбурге",
    qualification:
      "Первичный приём врача с учёной степенью доктора медицинских наук (Д.М.Н.)",
    price: 5000,
    specialty: "дерматовенеролог",
    scheduleSections: [
      "Дерматология взрослая",
      "Детский дерматологический приём",
      "Мужская венерология",
      "Женская венерология",
      "Приём сифилидолога",
    ],
    titleSeo:
      "Приём дерматовенеролога, доктора медицинских наук — 5 000 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация дерматовенеролога, доктора медицинских наук, в УрНИИДВиИ в Екатеринбурге. Стоимость — 5 000 рублей.",
    content:
      "Во время первичной консультации врач уточняет жалобы и анамнез, рассматривает результаты предыдущих обследований и определяет дальнейшую тактику в рамках своей компетенции.",
  },
  {
    slug: "zabor-materiala-dlya-issledovaniya",
    code: "B01.008.001",
    title: "Забор материала для исследования",
    h1: "Забор материала для исследования в Екатеринбурге",
    qualification: "Забор материала врачом-дерматовенерологом",
    price: 500,
    specialty: "дерматовенеролог",
    titleSeo: "Забор материала для исследования — 500 ₽ | УрНИИДВиИ",
    description:
      "Забор материала для исследования в УрНИИДВиИ в Екатеринбурге. Стоимость услуги по прайсу — 500 рублей.",
    content:
      "Необходимость и способ забора материала определяет медицинский специалист с учётом цели исследования и клинической ситуации. Уточните при записи, требуется ли предварительная консультация.",
  },
  {
    slug: "priem-nevrologa-pervichnyj",
    code: "B01.023.001",
    title: "Первичный приём врача-невролога",
    h1: "Первичный приём невролога в Екатеринбурге",
    qualification: "Врач с квалификацией «врач высшей категории»",
    price: 2600,
    specialty: "невролог",
    scheduleSection: "Прием невролога",
    titleSeo: "Первичный приём невролога в Екатеринбурге — 2 600 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация врача-невролога высшей квалификационной категории в УрНИИДВиИ. Стоимость — 2 600 рублей.",
    content:
      "На консультации врач уточняет жалобы и историю состояния, изучает предоставленные медицинские документы и определяет необходимость дальнейшего обследования.",
  },
  {
    slug: "priem-nevrologa-povtornyj",
    code: "B01.023.002",
    title: "Повторный приём врача-невролога",
    h1: "Повторный приём невролога в Екатеринбурге",
    qualification: "Врач высшей категории; в течение месяца",
    price: 1700,
    specialty: "невролог",
    scheduleSection: "Прием невролога",
    titleSeo: "Повторный приём невролога в Екатеринбурге — 1 700 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация врача-невролога высшей категории в УрНИИДВиИ в Екатеринбурге в течение месяца. Цена — 1 700 рублей.",
    content:
      "Повторная консультация позволяет обсудить результаты обследований, оценить изменения состояния и согласовать дальнейшие действия с врачом.",
  },
  {
    slug: "priem-terapevta-pervichnyj",
    code: "B01.047.001",
    title: "Первичный приём врача-терапевта",
    h1: "Первичный приём терапевта в Екатеринбурге",
    qualification: "Первичная консультация",
    price: 2100,
    specialty: "терапевт",
    scheduleSection: "Прием Терапевта",
    titleSeo: "Первичный приём терапевта в Екатеринбурге — 2 100 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация врача-терапевта в УрНИИДВиИ в Екатеринбурге. Стоимость по прайсу — 2 100 рублей.",
    content:
      "Врач уточняет жалобы, историю состояния и имеющиеся медицинские сведения, проводит осмотр в рамках консультации и при необходимости рекомендует дальнейшее обследование.",
  },
  {
    slug: "priem-terapevta-povtornyj",
    code: "B01.047.002",
    title: "Повторный приём врача-терапевта",
    h1: "Повторный приём терапевта в Екатеринбурге",
    qualification: "Повторная консультация",
    price: 1500,
    specialty: "терапевт",
    scheduleSection: "Прием Терапевта",
    titleSeo: "Повторный приём терапевта в Екатеринбурге — 1 500 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация врача-терапевта в УрНИИДВиИ в Екатеринбурге. Стоимость по прайсу — 1 500 рублей.",
    content:
      "Повторный приём предназначен для обсуждения результатов обследований и динамики состояния, а также уточнения дальнейших рекомендаций.",
  },
  {
    slug: "priem-urologa-pervichnyj",
    code: "B01.053.001",
    title: "Первичный приём врача-уролога",
    h1: "Первичный приём уролога в Екатеринбурге",
    qualification:
      "Врач с учёной степенью К.М.Н. или квалификацией «врач высшей категории»",
    price: 2600,
    specialty: "уролог",
    scheduleSection: "Прием уролога",
    titleSeo: "Первичный приём уролога в Екатеринбурге — 2 600 ₽ | УрНИИДВиИ",
    description:
      "Первичная консультация врача-уролога с учёной степенью К.М.Н. или высшей квалификационной категорией в УрНИИДВиИ. Цена — 2 600 рублей.",
    content:
      "На первичной консультации врач уточняет жалобы и анамнез, изучает предоставленные документы и определяет, требуется ли дополнительное обследование.",
  },
  {
    slug: "priem-urologa-povtornyj",
    code: "B01.053.002",
    title: "Повторный приём врача-уролога",
    h1: "Повторный приём уролога в Екатеринбурге",
    qualification:
      "Врач с учёной степенью К.М.Н. и/или квалификацией «врач высшей категории»; в течение месяца",
    price: 1700,
    specialty: "уролог",
    scheduleSection: "Прием уролога",
    titleSeo: "Повторный приём уролога в Екатеринбурге — 1 700 ₽ | УрНИИДВиИ",
    description:
      "Повторная консультация врача-уролога с учёной степенью К.М.Н. и/или высшей квалификационной категорией в течение месяца. Цена — 1 700 рублей.",
    content:
      "На повторной консультации врач оценивает динамику состояния и результаты обследований, после чего обсуждает дальнейшую тактику.",
  },
  {
    slug: "konsultaciya-fizioterapevta",
    code: "B01.054.001",
    title: "Осмотр (консультация) врача-физиотерапевта",
    h1: "Консультация физиотерапевта в Екатеринбурге",
    qualification: "Осмотр и консультация врача-физиотерапевта",
    price: 2100,
    specialty: "физиотерапевт",
    scheduleSection: "Приём физиотерапевта",
    titleSeo:
      "Консультация физиотерапевта в Екатеринбурге — 2 100 ₽ | УрНИИДВиИ",
    description:
      "Осмотр и консультация врача-физиотерапевта в УрНИИДВиИ в Екатеринбурге. Стоимость по прайсу — 2 100 рублей.",
    content:
      "Врач уточняет медицинский анамнез, оценивает имеющиеся назначения и противопоказания и определяет, какие физиотерапевтические методы могут рассматриваться в конкретном случае.",
  },
];

export default consultations;
